import { IdType } from 'epic/common-form/ReloadFormRequest';
import { useAssertedActiveTabId } from 'hooks/use-asserted-active-tab-id';
import { useAppSelector } from 'hooks/useAppSelector';
import { useDispatch } from 'react-redux';
import { useQuoteDetailsQuery } from 'routes/essential-workspace/components/header/more-actions/advanced-item/use-quote-details-query';
import { selectEssentialWorkflowStatus } from 'routes/essential-workspace/state/form.selectors';
import { EssentialWorkflowStatus } from 'routes/essential-workspace/state/model';
import { selectEssentialFormInfos } from 'state/essential/infos/selectors';
import { workspaceTabRepriceRequested } from 'state/workspaces/workspace.actions';

export function useAdvancedDropdownItem() {
  const tabId = useAssertedActiveTabId();
  const quoteId = useAppSelector(state => selectEssentialFormInfos(state, tabId)?.quoteId);
  const status = useAppSelector(state => selectEssentialWorkflowStatus(state, tabId));
  const dispatch = useDispatch();

  const repriceNotAllowedStatuses: EssentialWorkflowStatus[] = ['creating', 'not-ready', 'price-in-progress'];
  const canRequestReprice = !repriceNotAllowedStatuses.includes(status) && !!quoteId;

  const { details, loading } = useQuoteDetailsQuery(quoteId, !canRequestReprice);

  const reloadStaticAction = details?.actions?.find(action => action.type === 'NewStaticReprice');

  const isDisabled = !quoteId || loading || !reloadStaticAction || reloadStaticAction.isDisabled;
  const isLoading = loading || status === 'price-in-progress';

  const openInAdvancedWorkspace = () => {
    if (quoteId) {
      dispatch(
        workspaceTabRepriceRequested(
          quoteId,
          IdType.QuoteId,
          quoteId,
          null,
          'static',
          true,
          undefined,
          undefined,
          true,
        ),
      );
    }
  };

  return {
    disabledReasonTranslateKey: reloadStaticAction?.disabledReasonTranslateKey,
    isDisabled,
    isLoading,
    openInAdvancedWorkspace,
  };
}
